import React from 'react';
import PropTypes from 'prop-types';

import './view.scss';

export const ListView = ({ data }) => (
    <ul className="list">
        { data?.map((item) => item && (<li className="list__item">{ item?.desc }</li>)) }
    </ul>
);

ListView.propTypes = {
    data: PropTypes.instanceOf(Array).isRequired
};